import { Component, OnInit } from '@angular/core';
import { SolicitudIntermediarioService } from '../../Service/solicitudIntermediario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { Pais } from '../../../comun/models/pais';
import { Departamento } from '../../../comun/models/departamento';
import { Ciudad } from '../../../comun/models/ciudad';
import { Router } from '@angular/router';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { DataLocalStorageService } from '../../Service/dataLocalStorage.service';
import { AlertService } from '../../../services/alert.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { Constantes } from 'src/app/comun/data/constantes';
declare var $: any;
$(function () {
  $('[data-bs-toggle="tooltip"]').tooltip();
});

@Component({
    selector: 'app-aprobar-solicitudes-if',
    templateUrl: './aprobar-solicitudes-if.component.html',
    styleUrls: ['./aprobar-solicitudes-if.component.scss'],
    providers: [
        SolicitudIntermediarioService,
        ParametrosService,
        NeoIntermediarioFinancieroService,
    ],
    standalone: false
})
export class AprobarSolicitudesIfComponent implements OnInit {
  public departamentos: Departamento[] = [];
  public ciudades: Ciudad[] = [];
  public solicitudesPendientes: any[] = [];
  public user;
  habilitarCampos: Number = 0.1;
  estados: any[] = [];
  filterForm: UntypedFormGroup;
  paginaActual: Number = 1;
  totalPaginas: Number = null;

  constructor(
    private _solicitudIntermediarioService: SolicitudIntermediarioService,
    private _parametrosService: ParametrosService,
    private router: Router,
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _userIntermediarioService: UserService,
    private _dataLocalStorageService: DataLocalStorageService,
    private alertService: AlertService,
    private formBuilder: UntypedFormBuilder,
    private _sweetAlert: SweetAlertService
  ) {
    window.scroll(0, 0);
    this.user = this._userIntermediarioService.getUser();
    this.filterForm = this.formBuilder.group({
      idCiudad: null,
      idDepartamento: null,
      idSolicitud: null,
      fechaRecepcion: null,
      idEstadoSolicitud: null,
      idCliente: this.user.idCliente,
      isFilterDesembolso: false,
      isFilterRevisar: false,
      isFilterAprobar: true,
      pagina: this.paginaActual,
      idUsuario: this.user.idUsuario
    });
  }

  ngOnInit(): void {
    this.getSolicitudes();
    this._solicitudIntermediarioService.getEstadosIntermediario(this.user.idUsuario).subscribe(
      (response) => {
        var estadosCargados;
        estadosCargados = response.estados;
        estadosCargados.forEach((estado) => {
          if (
            estado.idEstadoSolicitudIntermediario == 3 ||
            estado.idEstadoSolicitudIntermediario == 4
          )
            this.estados.push(estado);
        });
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los datos');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._parametrosService.getDepartamentos('169').subscribe(
      (response) => {
        this.departamentos = response['data'];
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los departamentos');
      }
    );
  }

  getSolicitudes() {
    this.filterForm.get('pagina').setValue(this.paginaActual);
    this._neoIntermediarioFinancieroService
      .getFiltrarSolicitud(this.filterForm.value)
      .subscribe((data) => {
        this.solicitudesPendientes = data.data;
        this.totalPaginas = data.paginasTotales;
        return new Promise((resolve, reject) => {
          this.habilitarBotonesSolicitud();
        });
      });
  }

  changePage(i) {
    this.paginaActual = i;
    this.getSolicitudes();
  }

  habilitarBotonesSolicitud() {
    var idSolicitud = this._dataLocalStorageService.getIdSolicitudPendAprobar();
    if (idSolicitud != null) {
      this.solicitudesPendientes.forEach((element, index) => {
        if (element.numeroSolicitud == idSolicitud.toString()) {
          this.habilitarCampos = index;
          this._dataLocalStorageService.deleteIdSolicitudPendAprobar();
        }
      });
    }
  }

  getCiudades(idDepartamento) {
    if (idDepartamento != 'null') {
      this._parametrosService.getCiudades(idDepartamento).subscribe(
        (response) => {
          this.ciudades = response['data'];
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las ciudades');
        }
      );
    } else {
      this.ciudades = [];
    }
  }

  verSolicitud(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this.router.navigate([
      '/intermediario/revisar/revisarSolicitud/propuestaIntermediario/' +
      numeroSolicitud,
    ]);
  }

  verDetalleOfertaRevisor(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this._dataLocalStorageService.saveIdSolicitudPendAprobar(numeroSolicitud);
    this.router.navigate(
      [
        '/intermediario/consultar/detallePropuestaIF/verDetallePropuesta/' +
        numeroSolicitud,
      ],
      { state: { from: Constantes.TRANSACCIONAL } });
  }

  verDetalleSolicitud(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this._dataLocalStorageService.saveIdSolicitudPendAprobar(numeroSolicitud);
    this.router.navigate(
      [
        '/solicitud/intermediario/' + numeroSolicitud,
      ],
      { state: { from: Constantes.TRANSACCIONAL } });
  }

  aprobar(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    var estadoSolicitud =
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud;
    if (estadoSolicitud == 4) {
      this.router.navigate(
        [
          '/intermediario/transaccional/aprobarSolicitudes/aprobarOferta/' +
          numeroSolicitud,
        ],
        { state: { from: Constantes.TRANSACCIONAL } }
      );
    } else if (estadoSolicitud == 3) {
      this.router.navigate(
        [
          '/intermediario/transaccional/aprobarSolicitudes/confirmarNegacion/' +
          numeroSolicitud,
        ],
        { state: { from: Constantes.TRANSACCIONAL } }
      );
    }
  }

  negar(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this.router.navigate(
      [
        '/intermediario/transaccional/aprobarSolicitudes/negarOferta/' +
        numeroSolicitud,
      ],
      { state: { from: Constantes.TRANSACCIONAL } }
    );
  }

  devolver(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    var estadoSolicitud =
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud;
    if (estadoSolicitud == 4) {
      this.router.navigate(
        [
          '/intermediario/transaccional/aprobarSolicitudes/devolverOferta/' +
          numeroSolicitud,
        ],
        { state: { from: Constantes.TRANSACCIONAL } }
      );
    } else if (estadoSolicitud == 3) {
      this.router.navigate(
        [
          '/intermediario/transaccional/aprobarSolicitudes/devolverNegacion/' +
          numeroSolicitud,
        ],
        { state: { from: Constantes.TRANSACCIONAL } }
      );
    }
  }

  limpiarFiltro() {
    this.filterForm.get('idCiudad').setValue(null);
    this.filterForm.get('idDepartamento').setValue(null);
    this.filterForm.get('idSolicitud').setValue(null);
    this.filterForm.get('fechaRecepcion').setValue(null);
    this.filterForm.get('idEstadoSolicitud').setValue(null);
    this.filterForm.get('pagina').setValue(1);
    this.paginaActual = 1;
    this.getSolicitudes();
  }
}
